export default {
  ibt_gs_bd_edit_plan_button_sw: 'visit_id',
}
